import { useContext, useState } from "react";
import Button from "../../../elements/buttons/ButtonAction";
import ButtonAction from "../../../elements/buttons/ButtonAction";
import modalContext from "../../../../dataManager/context/modalContext";
import Input from "../../../elements/form/Input";
import { checkFiels } from "../../../../functions/functions";
import { toast } from "react-toastify";
import { resetPassword } from "../../../../api/admins/adminApi";

const UpdatePassword = () => {
  //context variable
  const { onClose } = useContext(modalContext);

  //state form variables
  const [newPassword, setNewPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    //check if the form is valid
    if (!checkFiels(newPassword) || newPassword.length < 6) {
      return setError(
        "Veuillez renseigner le nouveau mot de passe supérieur à 6 caractères"
      );
    }

    //start loading
    setLoading(true);

    //update password
    console.log(newPassword);
    const { data, error } = await resetPassword(newPassword);

    if (error) {
      setError(
        "Une erreur est survenue, veillez vous déconnecter et vous reconnecter avant de réessayer de modifier votre mot de passe"
      );
      return setLoading(false);
    }

    setLoading(false);
    toast.success("Mot de passe modifié avec succès", { theme: "colored" });
    onClose();
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="flex flex-col space-y-2">
        <Input
          labelName="Nouveau mot de pass"
          type="text"
          name="name"
          placeholder="XXXXXXXXX"
          value={newPassword}
          onChange={(e) => {
            setError("");
            setNewPassword(e.target.value);
          }}
        />
      </div>
      <div className="mt-4 flex items-center space-x-2">
        <Button size="small" loading={loading}>
          Modifier
        </Button>
        <ButtonAction size="small" type="secondary" onClick={onClose}>
          Anuler
        </ButtonAction>
      </div>
      <span className="font-nunito text-sm text-[#fc3838]">
        {error && error}
      </span>
    </form>
  );
};

export default UpdatePassword;
